import {DatabaseCode, toDatabaseCode} from "./database-code";

/**
 * The category of transport
 */
export type SettlementStatus = DatabaseCode

const open: SettlementStatus = {
  code: 'OPEN',
  displayValue: {
    id: 'common.entity.settlement.status.open',
    defaultMessage: 'Open',
  },
};

const volumeReview: SettlementStatus = {
  code: 'VOLUME_REVIEW',
  displayValue: {
    id: 'common.entity.settlement.status.volumereview',
    defaultMessage: 'Volume Review',
  },
};

const costReview: SettlementStatus = {
  code: 'COST_REVIEW',
  displayValue: {
    id: 'common.entity.settlement.status.costreview',
    defaultMessage: 'Cost Review',
  },
};

const adjustmentNeeded: SettlementStatus = {
  code: 'ADJUSTMENT_NEEDED',
  displayValue: {
    id: 'common.entity.settlement.status.adjustmentneeded',
    defaultMessage: 'Adjustment Needed',
  },
};

const invoicesSubmitted: SettlementStatus = {
  code: 'INVOICES_SUBMITTED',
  displayValue: {
    id: 'common.entity.settlement.status.invoicessubmitted',
    defaultMessage: 'Invoices Submitted',
  },
};

const approved: SettlementStatus = {
  code: 'APPROVED',
  displayValue: {
    id: 'common.entity.settlement.status.approved',
    defaultMessage: 'Approved',
  },
};

const closed: SettlementStatus = {
  code: 'CLOSED',
  displayValue: {
    id: 'common.entity.settlement.status.closed',
    defaultMessage: 'Closed',
  },
};

export const settlementStatus = {
  open,
  volumeReview,
  costReview,
  adjustmentNeeded,
  invoicesSubmitted,
  approved,
  closed,
};

export const settlementStatuses = Object.values(settlementStatus);

export const toSettlementStatus = (code: string): SettlementStatus => toDatabaseCode(code, settlementStatuses);
